import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, uaeProjectsBaseURL } from './../../../../../Containers/Config/index';
import { GET_LOCATION, GET_LOCATION_SUCCESS, GET_LOCATION_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getLocation({ payload }) {
  // let URL = `${uaeProjectsBaseURL}/admin/facilities`

  // let urlParams = ''
  // if (payload?.pagination) {
  //   urlParams = `${`pageIndex=${payload?.urlParam?.pageIndex}`}&${`pageSize=${Constant?.TABLE_PAGE_SIZE}`}`
  // } else {
  //   if (payload?.urlParam?.partnerId) {
  //     urlParams = `partnerId=${payload?.urlParam?.partnerId}&pageIndex=0&pageSize=100`
  //   } else if (payload?.urlParam?.categoryId) {
  //     urlParams = `categoryId=${payload?.urlParam?.categoryId}&pageIndex=0&pageSize=100`
  //   }
  // }

  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/facilities`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_LOCATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LOCATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LOCATION_ERROR, payload: error });
  }
}

export function* watchGetLocation() {
  yield takeEvery(GET_LOCATION, getLocation);
}

function* getLocationSaga() {
  yield all([fork(watchGetLocation)]);
}

export default getLocationSaga;
